import React from 'react'
import Select from 'react-select'

// import intentsList from './intents.json'

class IntentsAutocomplete extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentIntents: [],
        }
    }

    render() {
        return (
            <Select
                defaultValue={this.props.defaultValues}
                isMulti
                name='intents'
                options={this.props.intents}
                onChange={currentIntents => {
                    this.props.onChange(currentIntents)
                }}
                className='basic-multi-select'
                classNamePrefix='select'
            />
        )
    }
}

export default IntentsAutocomplete
